import { Constants } from 'services/constants';

export interface SessionCurrencySource {
    priceUnit?: string | null;
    stop?: {
        priceUnit?: string | null;
    } | null;
}

export const normalizeCurrencyCode = (currency?: string | null): string => {
    const normalized = currency?.trim().toUpperCase();
    return normalized || Constants.DEFAULT_CURRENCY_CODE;
};

export const getSessionCurrency = (
    session?: SessionCurrencySource | null,
): string => {
    return normalizeCurrencyCode(session?.stop?.priceUnit || session?.priceUnit);
};

export const formatCurrencyAmount = (
    amount?: number | string | null,
    currency?: string | null,
    locale = 'en-US',
): string => {
    const numericAmount = Number(amount ?? 0);
    const safeAmount = Number.isFinite(numericAmount) ? numericAmount : 0;
    const normalizedCurrency = normalizeCurrencyCode(currency);

    try {
        return new Intl.NumberFormat(locale.replace('_', '-'), {
            style: 'currency',
            currency: normalizedCurrency,
            currencyDisplay: 'code',
        }).format(safeAmount);
    } catch {
        return `${safeAmount.toFixed(2)} ${normalizedCurrency}`;
    }
};
